import React, { useEffect, useState } from "react";
import { Button, Typography, Space, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import gmailIcon from "../../Assets/EmailCapture/gmail-icon.png";
import "./NewEmailSetup.css";
import axios from "axios";
import { URL } from "../../helper/Mainurl";
import { get } from "lodash";

const { Title, Paragraph } = Typography;

const StepTwo = ({ onStart, onClose }) => {
  const [selectedProvider, setSelectedProvider] = useState("gmail");
  useEffect(() => {
    // Fetch Google Auth URL when component mounts
    getGoogleAuthApi();
  }, []);
  const submitAuthorization = async (status) => {
    const token = localStorage.getItem("authToken");

    // 1. Trigger Google Auth popup
    await GoogleAuthApi();

    // 2. Proceed with internal authorization
    try {
      const response = await axios.post(
        `${URL}/v1/email-assistant/authorization-setup`,
        {
          email_provider: selectedProvider || 'gmail',
          authorization_status: status,
        },
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success(
        response?.data?.message || `${status === 'authorized' ? 'Authorized' : 'Skipped'} successfully.`
      );

      onStart(2); // move to next step regardless
    } catch (error) {
      console.error(`${status} failed:`, error);
      // Try to show backend error message if available
      const backendMsg =
        error.response?.data?.message ||
        (error.response?.data?.errors && Object.values(error.response.data.errors).flat().join(", "));
      message.error(backendMsg || `Failed to ${status}.`);
    }
  };
  const getGoogleAuthApi = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await fetch(`${URL}/v1/get-profile`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (data.code === 200 && data.data) {
      }
    } catch (error) {
      console.error("Error fetching Google Auth URL:", error);
      message.error("Failed to initiate Google Auth.");
    }
  };
  // const GoogleAuthApi = async () => {
  //   const token = localStorage.getItem('authToken');

  //   try {
  //     // Step 1: Get the Google OAuth redirect URL
  //     const response = await fetch(`${URL}/v1/auth/google/link`, {
  //       method: 'GET',
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //       redirect: 'manual',
  //     });

  //     const redirectUrl = response.headers.get('Location');

  //     if (!redirectUrl) {
  //       message.error("Failed to initiate Google Auth.");
  //       return;
  //     }

  //     // Step 2: Open OAuth in a popup
  //     const authWindow = window.open(redirectUrl, 'GoogleAuth', 'width=500,height=600');

  //     // Step 3: Poll until popup is closed
  //     const pollTimer = window.setInterval(() => {
  //       if (authWindow.closed) {
  //         clearInterval(pollTimer);
  //         message.success("Google authorization completed.");
  //       }
  //     }, 1000);
  //   } catch (error) {
  //     message.error("Google authorization failed.");
  //     console.error(error);
  //   }
  // };

  const GoogleAuthApi = async () => {
    const token = localStorage.getItem("authToken");

    try {
      // Step 1: Get Google Auth URL
      const { data } = await axios.get(`${URL}/v1/auth/google/link`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const authUrl = data.authUrl;

      // Step 2: Open the popup
      const authWindow = window.open(authUrl, "_blank", "width=500,height=600");

      // // Step 3: Poll for completion
      // const pollTimer = window.setInterval(() => {
      //   try {
      //     const popupUrl = authWindow?.location.href;

      //     // Detect redirect back to frontend success page
      //     if (popupUrl.includes('yourapp.com/auth-success')) {
      //       clearInterval(pollTimer);
      //       authWindow.close();
      //       message.success("Google authorization completed.");
      //     }
      //   } catch (err) {
      //     // Cross-origin error until it redirects back to your domain – this is expected
      //   }

      //   if (authWindow?.closed) {
      //     clearInterval(pollTimer);
      //   }
      // }, 1000);
    } catch (error) {
      message.error("Google authorization failed.");
      console.error(error);
    }
  };

  const handleSelect = (provider) => {
    setSelectedProvider(provider);
  };

  return (
    <div>
      {/* Close Button */}
      <div
        style={{ display: "flex", justifyContent: "end", alignItems: "center" }}
      >
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          style={{ color: "#bbb", opacity: "1" }}
        />
      </div>

      <div className="emailSetupStep1Cont">
        <Title className="emailSetupTitleBtm" level={3}>
          Connect Your Email
        </Title>
        <Paragraph className="emailSetupTxtBtm">
          Quelld will securely scan school emails to identify events, deadlines,
          and reminders.
        </Paragraph>

        {/* Email Provider Icons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 30,
            margin: "30px 0",
          }}
        >
          <img
            src={gmailIcon}
            alt="Gmail"
            onClick={() => handleSelect("gmail")}
            style={{
              width: 60,
              height: 60,
              cursor: "pointer",
              border:
                selectedProvider === "gmail" ? "2px solid #9A4FE0" : "none",
              borderRadius: 10,
            }}
          />
        </div>

        <Space direction="vertical" style={{ width: "100%" }}>
          {/* <Button
            type="primary"
            block
            disabled={!selectedProvider}
            className='setup-btn'
            onClick={() => submitAuthorization('authorized')}
          >
            Authorise Access
          </Button> */}
          <a
            href={`${URL}/v1/auth/google/link?source=email_capture`}
            target=""
            rel="noopener noreferrer"
          >
            <Button
              type="primary"
              block
              disabled={!selectedProvider}
              className="setup-btn"
              // onClick={() => getGoogleAuthApi()}
            >
              Authorise Access
            </Button>
          </a>


          <Button
            className="setup-btn"
            block
            onClick={() => submitAuthorization("skipped")}
          >
            Skip for Now
          </Button>
        </Space>

        <Paragraph
          style={{
            textAlign: "center",
            marginTop: 16,
            fontSize: 12,
            color: "#999",
          }}
        >
          We only scan for related emails. Your data is private.
        </Paragraph>
      </div>
    </div>
  );
};

export default StepTwo;
